import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import {
    PDF_BACKGROUND_SCOPE_LABELS,
    PDF_BACKGROUND_TYPE_LABELS,
    PdfBackground,
} from '@/models/pdfBackground';

type Props = {
    background: PdfBackground | null;
    onConfirm: () => void;
    onClose: () => void;
};

export const PdfBackgroundDeleteDialog: FunctionComponent<Props> = ({
    background,
    onConfirm,
    onClose,
}) => {
    const open = background !== null;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Vorlage löschen</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {background && (
                        <>
                            Möchten Sie die Vorlage{' '}
                            <strong>
                                {PDF_BACKGROUND_TYPE_LABELS[background.type]} ·{' '}
                                {PDF_BACKGROUND_SCOPE_LABELS[background.scope]}
                            </strong>{' '}
                            wirklich löschen? Beim Druck wird stattdessen die
                            nächst-allgemeinere Vorlage (oder die
                            Starjack-Standardvorlage) verwendet.
                        </>
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button color='error' variant='contained' onClick={onConfirm}>
                    Löschen
                </Button>
            </DialogActions>
        </Dialog>
    );
};
